const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'FEEDBACK_MOTORISTA_TIPO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'FEEDBACK_MOTORISTA_TIPO_LISTADO':
            return { ...state, lista: action.payload.data };

        default:
            return state;
    }
}
